import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import router from "@/views/base/routes";

export default (urlPrefix: string): AxiosInstance => {
  const options: AxiosRequestConfig = {
    baseURL: `${process.env.VUE_APP_API_URL}/${urlPrefix}`,
    headers: {
      "Content-type": "application/json",
      Access: "application/json"
    }
  };

  const instance = axios.create(options);

  instance.interceptors.request.use(config => {
    const token = sessionStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        sessionStorage.removeItem("token");
        router.push({ path: "/login" });
      }

      return Promise.reject(error);
    }
  );
  
  return instance;
};